module.exports = __webpack_public_path__ + "static/img/business14.4389906.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business14.jpg
// module id = IjXi
// module chunks = 9